import React from "react";

const SpecList = ({ productInfo }) => {
  return (
    <div className="col-12 col-12 col-md-12 col-lg-12">
      <div className="product-details-gallery">
        <div className="list-group content-list">
          <div style={{ display: "flex", flexDirection: "row" }}>
            <p
              style={{ fontSize: 19, fontWeight: "bold", fontFamily: "Gilroy" }}
            >
              <i class="fa fa-dot-circle-o" aria-hidden="true"></i> Camera:{" "}
              {"  "}
            </p>
            <p style={{ fontSize: 16, marginLeft: 5 }}>
              {productInfo && productInfo.camera
                ? productInfo.camera + " MP"
                : "N/A"}
            </p>
          </div>

          <div style={{ display: "flex", flexDirection: "row" }}>
            <p
              style={{ fontSize: 19, fontWeight: "bold", fontFamily: "Gilroy" }}
            >
              <i class="fa fa-dot-circle-o" aria-hidden="true"></i> Size:
              {"  "}
            </p>
            <p style={{ fontSize: 16, marginLeft: 5 }}>
              {productInfo &&
              productInfo.productDetails &&
              productInfo.productDetails.display &&
              productInfo.productDetails.display.size
                ? `${productInfo.productDetails.display.size} `
                : "N/A"}
            </p>
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <p
              style={{ fontSize: 19, fontWeight: "bold", fontFamily: "Gilroy" }}
            >
              <i class="fa fa-dot-circle-o" aria-hidden="true"></i> Company:
              {"  "}
            </p>
            <p style={{ fontSize: 16, marginLeft: 5 }}>
              {productInfo && productInfo.company_name
                ? productInfo.company_name
                : "N/A"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecList;
